module.exports = __webpack_public_path__ + "static/media/fact.50dceb51.png";